import { createFileRoute } from '@tanstack/react-router'
import { AgentRunsPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/runs')({
  component: AgentRunsPage,
})
